import styled from '@emotion/styled'
import { colors, typography } from '@resiliatech/birdsong'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
`

export const TaskListContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-x: hidden;
`

export const HeaderRow = styled.div`
  display: grid;
  grid-template-columns:
    20px minmax(0, 3fr) minmax(0, 120px) minmax(0, 120px) minmax(0, 150px)
    60px;
  align-items: center;
  padding: 16px;
  background-color: #f5f5f5;
  border-bottom: 1px solid ${colors.interactive.secondaryHoverFocus};
`

export const HeaderCell = styled.div`
  ${typography.down1.semiBoldSans}
  color: ${colors.text.primary};
  padding: 0 8px;
`

export const ScrollableContent = styled.div`
  max-height: 360px;
  overflow-y: auto;
  width: 100%;
`

export const TaskRow = styled.div`
  display: grid;
  grid-template-columns:
    20px minmax(0, 3fr) minmax(0, 120px) minmax(0, 120px) minmax(0, 150px)
    60px;
  align-items: center;
  padding: 16px;
  background-color: white;
  border-bottom: 1px solid ${colors.background.primaryBackground};

  &:hover {
    background-color: ${colors.background.secondaryBackground};
  }
`

export const TaskCell = styled.div`
  padding: 0 8px;
  display: flex;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const TaskNameCell = styled(TaskCell)`
  ${typography.baseline.regularSans}
  gap: 12px;
  max-width: calc(100% - 10px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const StatusCell = styled(TaskCell)`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const DateCell = styled(TaskCell)`
  ${typography.down1.regularSans}
  color: ${colors.text.secondary};
`

export const OwnerCell = styled(TaskCell)`
  ${typography.down1.regularSans}
  display: flex;
  align-items: center;
  gap: 8px;
`

export const ActionsCell = styled(TaskCell)`
  justify-content: center;
  width: 100%;
`

export const UserAvatar = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  ${typography.down2.semiBoldSans}
  color: #555;
  flex-shrink: 0;
`

export const UserInfo = styled.div`
  ${typography.baseline.regularSans}
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

// Using a button instead of IconButton
export const ActionsButton = styled.button`
  padding: 8px;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  min-width: 36px;
  min-height: 36px;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`

export const StatusPill = styled.div<{ status: string }>`
  display: flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  background-color: ${({ status }) => {
    switch (status) {
      case 'completed':
        return colors.illustration.lightGreen10
      case 'in progress':
        return colors.illustration.lightOrange10
      default:
        return colors.interactive.secondaryHoverFocus
    }
  }};
  color: ${({ status }) => {
    switch (status) {
      case 'completed':
        return colors.illustration.darkGreen
      case 'in progress':
        return colors.illustration.darkOrange
      default:
        return colors.text.primary
    }
  }};
`

export const CheckboxContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

// Filter and Sort components
export const ControlsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  @media (max-width: 768px) {
    display: none;
  }
`

// Using a div instead of Box
export const SortButton = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #003f7e;
  font-size: 14px;
  gap: 4px;
  padding: 8px 12px;
  border-radius: 4px;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`

// Using a div instead of Box
export const FilterButton = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  gap: 4px;
  padding: 8px 12px;
  border-radius: 4px;
  color: #003f7e;
  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
  gap: 24px;
  min-height: 200px;
`

export const EmptyStateTitle = styled.h3`
  ${typography.up1.regularSerif}
  margin: 0;
`

export const EmptyStateText = styled.p`
  ${typography.baseline.regularSans}
  color: ${colors.text.secondary};
  margin: 0;
  max-width: 500px;
`
